<template>
  <div class="nuttrema-biography">

    <section v-if="experiences">
      <h4 class="section-title">{{ $t('label.experience') }}</h4>
      <ul class="nuttrema-biography-list">
        <li v-for="experience in experiences">
          <div class="nuttrema-biography-list__date">
            <span>
              {{ experience.date_from | moment('MMM YYYY') }} - <span v-if="experience.date_to">{{ experience.date_to | moment('MMM YYYY') }}</span><span v-else>{{ $t('label.present') }}</span>
            </span>
          </div>
          <div class="nuttrema-biography-list__description">
            <div class="description__text">
              <p class="description__position">{{ experience.position }}</p>
              <p class="description__company">{{ experience.company }}</p>
              <p class="description__company_info">
                <span v-if="experience.city">{{ experience.city }}</span><span v-if="experience.Region">, {{ _get(experience, 'Region.title') }}</span>
              </p>
              <p v-if="experience.description" class="description__job">
                {{ $t('label.job_description') }}: {{ experience.description }}
              </p>
            </div>
            <div class="description__action" v-if="edit">
              <popover-question-alert
                 slot="bottom-right"
                 buttonTitle="label.delete"
                 buttonType="danger"
                 popoverWidth="280"
                 popoverTitle="label.delete"
                 popoverText="label.delete_sure"
                 popoverPlacement="top-end"
                 buttonSize="small"
                :popoverShouldShow="true"
                @confirmed="onRemoveConfirm('experience', experience.id)">
              </popover-question-alert>
              <router-link tag="a" activeClass="is-active" class="el-button el-button--text el-button--list-item"
                :to="{ name: meta.navigation.editExperience, params: { id: experience.id }}">
                {{ $t('label.edit') }} <i class="el-icon-arrow-right el-icon-right"></i>
              </router-link>
            </div>
          </div>
        </li>
      </ul>
    </section>

    <section v-if="educations">
      <h4 class="section-title">{{ $t('label.education') }}</h4>
      <ul class="nuttrema-biography-list">
        <li v-for="education in educations">
          <div class="nuttrema-biography-list__date">
            <span>
              {{ education.date_from | moment('MMM YYYY') }} - <span v-if="education.date_to">{{ education.date_to | moment('MMM YYYY') }}</span><span v-else>{{ $t('label.present') }}</span>
            </span>
          </div>
          <div class="nuttrema-biography-list__description">
            <div class="description__text">
              <p class="description__position">
                  {{ education.school }}<template v-if="education.city">, {{ education.city }}</template><template v-if="education.Region">, {{ _get(education, 'Region.title') }}</template>
                </p>
              <p class="description__company">
                {{ education.degree }}<template v-if="education.field_of_study">, {{ education.field_of_study }}</template><template v-if="education.grade">, {{ $t('label.grade') }}: {{ education.grade }}</template>
              </p>
              <p v-if="education.link" class="description__job">
                {{ $t('label.school_web_site') }}: <a :href="education.link" rel="no-fallow" target="_blank">{{ education.link }}</a>
              </p>
              <p v-if="education.description" class="description__job">
                {{ $t('label.description') }}: {{ education.description }}
              </p>
            </div>
            <div class="description__action" v-if="edit">
              <popover-question-alert
                 slot="bottom-right"
                 buttonTitle="label.delete"
                 buttonType="danger"
                 popoverWidth="280"
                 popoverTitle="label.delete"
                 popoverText="label.delete_sure"
                 popoverPlacement="top-end"
                 buttonSize="small"
                :popoverShouldShow="true"
                @confirmed="onRemoveConfirm('education', education.id)">
              </popover-question-alert>
              <router-link tag="a" activeClass="is-active" class="el-button el-button--text el-button--list-item"
                :to="{ name: meta.navigation.editEducation, params: { id: education.id }}">
                {{ $t('label.edit') }} <i class="el-icon-arrow-right el-icon-right"></i>
              </router-link>
            </div>
          </div>
        </li>
      </ul>
    </section>

    <section v-if="_get(PersonalProfile, 'data.PersonData.professional_biography_interests.value')">
      <h4 class="section-title">{{ $t('label.interests') }}</h4>
      <ul class="nuttrema-biography-list">
        <li>
          <div class="nuttrema-biography-list__date"></div>
          <div class="nuttrema-biography-list__description">
            <p class="description__company">
              {{ _get(PersonalProfile, 'data.PersonData.professional_biography_interests.value') }}
            </p>
            <div class="description__action" v-if="edit">
              <router-link tag="a" activeClass="is-active" class="el-button el-button--text el-button--list-item"
                :to="{ name: meta.navigation.editInterests }">
                {{ $t('label.edit') }} <i class="el-icon-arrow-right el-icon-right"></i>
              </router-link>
            </div>
          </div>
        </li>
      </ul>
    </section>

  </div>
</template>

<script>
import { get, orderBy } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';

export default {
  name: 'cmpt-my-preferences-professional-biography',
  props: {
    PersonalProfile: {
      required: true,
      default: null,
    },
    PersonalBiography: {
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
    meta: {
      required: true,
    },
  },
  components: {
    PopoverQuestionAlert,
    NuttremaLayoutFormStandard,
  },
  computed: {
    experiences() {
      const personExperience = get(this.PersonalBiography, 'data.PersonExperience', []);
      return orderBy(personExperience, ['date_to', 'date_from'], ['desc', 'desc']);
    },
    educations() {
      const personEducation = get(this.PersonalBiography, 'data.PersonEducation', []);
      return orderBy(personEducation, ['date_to', 'date_from'], ['desc', 'desc']);
    },
  },
  methods: {
    onRemoveConfirm(type, id) {
      this.$emit('remove', type, id);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";

  .nuttrema-biography {
    flex-grow: 1;
    height: 100%;
    display: flex;
    overflow-y: auto;
    position: relative;
    align-self: stretch;
    flex-direction: column;

    section {
      z-index: 1;
      flex-grow: 1;
      padding: 2em;
      display: flex;
      flex-shrink: 0;
      padding-right: 0;
      align-self: stretch;
      flex-direction: column;

      .section-title {
        font-size: 1rem;
        font-weight: 500;
        padding: 0 0 0.25em 0;
        margin-bottom: 1.25em;
        border-bottom: 1px solid #DBE2EF;
      }

      .nuttrema-biography-list {
        display: flex;
        flex-direction: column;
        align-self: stretch;
        > li {
          display: flex;
          align-items: flex-start;

          .nuttrema-biography-list__date {
            width: 15em;
            display: flex;
            flex-shrink: 0;
            padding-right: 1em;
            align-items: flex-end;
            flex-direction: column;
            > span {
              font-weight: 500;
              color: $gray;
            }
          }

          .nuttrema-biography-list__description {
            flex-grow: 1;
            display: flex;
            margin-bottom: 1em;
            padding-bottom: 1em;
            align-self: stretch;
            align-items: flex-start;
            justify-content: space-between;
            border-bottom: 1px solid $tabs-border-bottom-color;

            .description__text {
              flex-grow: 1;
              align-self: flex-start;

              .description__position {
                color: $primary-color;
                font-weight: 500;
              }
              .description__company {
                font-weight: 500;
                color: $gray;
              }

              .description__job {
                font-size: 0.9em;
                color: $gray;
              }
            }

            .description__action {
              margin: 0 1em;
              display: flex;
              flex-shrink: 0;
              align-self: stretch;
              align-items: center;
              justify-content: flex-end;
            }

          }

        } // end ~ li

      } // end ~ nuttrema-biography-list

    } // end ~ section

  } // end ~ nuttrema-biography
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/settings/my-preferences/professional-biography/cmpt-my-preferences-professional-biography.vue